// extracted by mini-css-extract-plugin
export default {"PreLoaderCont":"PreLoader_PreLoaderCont__J0ZYL","PreLoader":"PreLoader_PreLoader__9z9Ko","PreLoaderDots":"PreLoader_PreLoaderDots__7DE29","bounce":"PreLoader_bounce__tlm6B"};